import { css } from '@compiled/react';
import { useIntl } from 'react-intl';

import Spinner from '@atlaskit/spinner';

import { LOADING_STATE_TEST_ID } from '../../utils/perceived-provisioning/constants';
import { JiraOnboardingContainer } from '../jira/jira-onboarding-container/jira-onboarding-container';

import { workStyleChoiceMessages } from './work-style-choice-messages';

const spinnerContainerStyles = css({
	display: 'flex',
	flex: 1,
	alignItems: 'center',
	justifyContent: 'center',
});

export const WorkStyleChoiceLoadingState = () => {
	const intl = useIntl();

	return (
		<JiraOnboardingContainer
			header={intl.formatMessage(workStyleChoiceMessages.header)}
			subheader={intl.formatMessage(workStyleChoiceMessages.subheader)}
		>
			<div css={spinnerContainerStyles} data-testid={LOADING_STATE_TEST_ID}>
				<Spinner size="large" />
			</div>
		</JiraOnboardingContainer>
	);
};
